export enum ExpiresModeOptions {
  Never = `Never`,
  Specify = `Specify...`,
}

export enum ExpiresUnit {
  Hour = `Hours`,
  Day = `Days`,
  Month = `Months`,
  Year = `Years`,
}
